import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmcbum4yyt: FaireProductEntity = {
  token: "p_qmcbum4yyt",
  type: "product",
  name: "nutcracker watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/de27c6744583ab95be1d8094e70bad8d32cdb6f19f6c39ef937a19cd909504d3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b068a4a86e57e4dd494d192c3bb086a18eeb34f388bd8fc3c269fd00a433e14f.jpeg",
    "https://cdn.faire.com/fastly/f9d5c941686aad681d04ee8c0fae99eee7fd78d1efbfb8b622a523bca4617122.jpeg",
    "https://cdn.faire.com/fastly/814a7100b74676852630059c0491391162802697e5ca84e84f4c4d322ec3b435.jpeg",
    "https://cdn.faire.com/fastly/625d37741d2111dc7e36746e6f8bfd10227cfcdec542331fbbee56d9589cae6b.jpeg",
    "https://cdn.faire.com/fastly/f7b0d70f18928d509f444149698abb859f99f7d3220950bebad838ff20c8d791.jpeg",
    "https://cdn.faire.com/fastly/30440adb5de4001a0898cdc84910669f5872f9683f0e0d301d6886d8692ca9e5.jpeg",
    "https://cdn.faire.com/fastly/8063f7f5c8bc96f7a039321e125ff96eaeccb8b6266f84d5f62089b86df064ac.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve illustrations from the holiday classic — Clara, the Nutcracker soldier, the Christmas tree, the Mouse King, the Sugar Plum Fairy, a ballerina, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA holiday standout. Reorder by early October. Pairs naturally with the Christmas workbook for a holiday display.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:10.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
